import { render, staticRenderFns } from "./TextFieldAutocomplete.vue?vue&type=template&id=5596d18e"
import script from "./TextFieldAutocomplete.vue?vue&type=script&lang=js"
export * from "./TextFieldAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports